import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { mdiChevronDown } from '@mdi/js';
import Icons from '../Icon';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const CollapseWithLabel = ({ children, label }) => {
  const [expand, setExpand] = useState(false);

  return (
    <>
      <h2 className="d-inline">{label}</h2>
      <ExpandMore
        expand={expand}
        onClick={() => setExpand((prev) => !prev)}
        aria-expanded={expand}
      >
        <Icons path={mdiChevronDown} />
      </ExpandMore>
      <Collapse in={expand}>{children}</Collapse>
    </>
  );
};
